<template>

  <div class="p-list-representation-record-modal-content w-100 row">
    <form id="signup-form" class="row w-100" v-on:submit.prevent="submit">

      <!-- <div :class="{ 'p-list-representation-error': $v.formData.nameFamily.$error }" class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
        <label  class="ml-4 p-list-representation-label-text mb-2 mb-lg-0 p-edit-representation-form-text">
          نام
        </label>
        <input v-model="formData.nameFamily" type="text" placeholder="" class="form-control text-right col-lg-9 pr-3 pl-2 pr-2">
      </div> -->

      <div :class="{ 'p-list-representation-error': $v.formData.name.$error }" class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
        <label  class="ml-4 p-list-representation-label-text mb-2 mb-lg-0 p-edit-representation-form-text">
          نام
        </label>
        <input v-model="formData.name" type="text" placeholder="" class="form-control text-right col-lg-9 pr-3 pl-2 pr-2">
      </div>

      <div :class="{ 'p-list-representation-error': $v.formData.family.$error }" class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
        <label  class="ml-4 p-list-representation-label-text mb-2 mb-lg-0 p-edit-representation-form-text">
          نام خانوادگی
        </label>
        <input v-model="formData.family" type="text" placeholder="" class="form-control text-right col-lg-9 pr-3 pl-2 pr-2">
      </div>

      <div :class="{ 'p-list-representation-error': $v.formData.mobile.$error }" class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
        <label  class="ml-4 p-list-representation-label-text mb-2 mb-lg-0 p-edit-representation-form-text">
          موبایل صاحب
        </label>
        <input v-model="formData.mobile" type="text" placeholder="" class="form-control text-right col-lg-9 pr-3 pl-2 pr-2">
      </div>

      <div :class="{ 'p-list-representation-error': $v.formData.national_code.$error }"  class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
        <label   class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
          کد ملی
        </label>
        <input v-model="formData.national_code" type="text" placeholder="" class="form-control text-right col-lg-9 pr-3 pl-2 pr-2">
      </div>


      <div :class="{ 'p-list-representation-error': $v.formData.shaba_code.$error }"  class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
        <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
          شماره شبا
        </label>
        <input v-model="formData.shaba_code" type="text" placeholder="" class="form-control text-right col-lg-9 pr-3 pl-2 pr-2">
      </div>


      <div :class="{ 'p-list-representation-error': $v.formData.bank_name.$error }"  class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
        <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
          نام بانک
        </label>
        <input v-model="formData.bank_name" type="text" placeholder="" class="form-control text-right col-lg-9 pr-3 pl-2 pr-2">
      </div>

      <div :class="{ 'p-list-representation-error': $v.formData.bank_owner_name.$error }" class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
        <label  class=" p-list-representation-label-text mb-2 mb-lg-0 p-edit-representation-form-text">
          نام و نام خانوادگی صاحب حساب
        </label>
        <input v-model="formData.bank_owner_name" type="text" placeholder="" class="form-control text-right col-lg-7 pr-3 pl-2 pr-2">
      </div>

      <div class="w-100 row mb-5 mt-4">

            <div class="row p-list-salon-owner-upload-file-main">
                  <h3 class="p-list-salon-owner-upload-title justify-content-center w-100 d-flex mb-3">تصویر کارت ملی </h3>

                  <div class="w-100 row">
                      <div class="d-flex justify-content-center  p-list-salon-owner-uload-file-data position-relative">
                        <img :src="previewImage" v-if=" previewImage != '' " class="p-list-salon-owner-pic-upload" alt="">
                      </div>
                      <div class="d-flex p-list-salon-owner-upload-delete justify-content-end w-100 mt-2 mb-2">
                        <button @click="removePic" type="button" class="btn btn-primary btn-red remove-radius col-lg-4">حذف</button>
                      </div>
                  </div>

                  <div  :class="{ 'p-upload-error': $v.previewImage.$error }" class="p-list-representation-select-modal-main row justify-content-center">
                        <div class="input-group ltr ">
                            <div class="input-group-prepend">
                              <span id="inputGroupFileAddon01" class="input-group-text">انتخاب فایل</span>
                            </div>
                            <div class="custom-file">
                              <input @change="uploadImage" type="file" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01" class="custom-file-input">
                              <label for="inputGroupFile01" class="custom-file-label">
                              </label>
                            </div>
                        </div>
                  </div>
            </div>


      </div>

      <div class="w-100 row justify-content-center">
        <button  type="submit" class="btn btn-primary btn-blue col-lg-2">ثبت نماینده </button>
      </div>

    </form>
  </div>

</template>

<script>
import { required, minLength,between,numeric } from 'vuelidate/lib/validators'

const checkTypeValueAndLenValue = (value,countCheckValue) => {
    const checkTypeValue = /^\d+$/.test(value);

    if (checkTypeValue) {
      if (value.length == countCheckValue) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
}

export default {
  name: 'fromData',
  props: {
    formDataOriginal  : {type:[Array,Object],default:[]},
  },

  data() {
    return {
      formData    : {
      },
      previewImage  : '',

    }
  },

  validations: {
    previewImage: {
      required,
    },
    formData : {
      // nameFamily: {
      //   required,
      // },
      name: {
        required,
      },
      family: {
        required,
      },
      bank_owner_name: {
        required,
      },
      bank_name: {
        required,
      },
      mobile: {
        required,
        numeric,
        currentFunc (value) {
          return /^09[0-9]{9}$/.test(value);
        },
      },
      national_code: {
        required,
        numeric,
        currentFunc (value) {
          return checkTypeValueAndLenValue(value,10)
        },
      },
      shaba_code: {
        required,
        numeric,
        currentFunc (value) {
          return checkTypeValueAndLenValue(value,24)
        },
      },





    }


  },


  computed: {

  },

  created() {
    this.formData     = this.formDataOriginal;
    if (typeof(this.formDataOriginal.id) != 'undefined') {
      this.previewImage = this.formData.national_card;
    }
  },

  mounted () {
  },

  watch: {

  },

  methods: {
    submit() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$message.error('لطفا اطلاعات خود را بررسی کنید')
      }
      else {
        this.$emit('submitForm',this.formData)
      }

    },

    removePic(){
      this.previewImage           = '';
      this.formData.national_card = {};
    },

    uploadImage(e){
       const image = e.target.files[0];
       const reader = new FileReader();
       reader.readAsDataURL(image);
       reader.onload = e =>{
           this.previewImage = e.target.result;
       };

       this.formData.national_card = image;
   }

  },

}
</script>
